import { render, staticRenderFns } from "./UICardBordered.vue?vue&type=template&id=0bfcd678"
import script from "./UICardBordered.vue?vue&type=script&lang=js"
export * from "./UICardBordered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports